import 'ol/ol.css';

import 'cadenza/map/custom/default/map.css';
import 'cadenza/map/custom/default/map';
import { showHelpDialogIfNotLocallyDisabled } from 'cadenza/navigator/help-dialog/help-dialog';
import 'cadenza/map/layer-configuration-panel/layer-configuration-panel';
import { renderAttachmentList, renderAttachmentGrid } from 'cadenza/map/feature-info-utils';
import 'cadenza/map-dashboard/map-dashboard';
import 'cadenza/map-dashboard/map-view/map-view';
import 'cadenza/map-dashboard/table-view/table-view';
import 'cadenza/loading-state-cover/loading-state-cover';

import './wps.entry.js';

Object.assign(window.disyCommons, {
  featureInfoUtilities: {
    renderAttachmentList,
    renderAttachmentGrid
  },
  showHelpDialogIfNotLocallyDisabled
});
